import { Text, TextLink } from '@cinch-labs/design-system'
import styles from './compliance.module.css'

export const Compliance = () => (
  <div className={styles.container}>
    <Text fontWeight="bold" element="div" className={styles.heading}>
      Used cars are sold by cinch cars limited.
    </Text>
    <Text>
      Cinch Cars Limited is an appointed representative of{' '}
      <TextLink isOnlyWhite href="https://www.marshall.co.uk" target="_blank">
        Marshall Motor Group
      </TextLink>{' '}
      which is authorised and regulated by the Financial Conduct Authority
      (their registration number is 310503). Permitted activities include
      advising on and arranging general insurance contracts and acting as a
      credit broker not a lender.
    </Text>
    <Text>
      We can introduce you to a limited number of finance providers. We do not
      charge a fee for our Consumer Credit services. We do not act as a
      financial adviser, or fiduciary. We act in our own interest, whichever
      lender we introduce you to, we will typically receive commission from them
      based on either a fixed fee or a fixed percentage of the amount you
      borrow. Any and all commission amounts will be fully disclosed to you as
      part of your sales journey. You will be required to give your fully
      informed consent to our receipt of this commission. By doing this, you
      acknowledge that you understand our role as a credit broker, and that we
      will receive a financial incentive if you take out a loan from a lender
      that we introduce you to.
    </Text>
    <Text>
      All finance applications are subject to status, terms and conditions
      apply, UK residents only, 18’s or over, Guarantees may be required.
    </Text>

    <hr />

    <Text fontWeight="bold" element="div" className={styles.heading}>
      New cars are sold by Marshall Motor Group, who will also arrange any
      finance for those cars.
    </Text>
    <Text>
      Marshall Motor Group Limited is authorised and regulated by the Financial
      Conduct Authority. Our Firm Reference Number is 310503.
    </Text>
    <Text>
      Details of our permissions and trading names can be checked via the FCA
      register{' '}
      <TextLink
        isOnlyWhite
        href="https://register.fca.org.uk/s/"
        target="_blank"
      >
        https://register.fca.org.uk/s/
      </TextLink>
    </Text>
  </div>
)
